import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Header from '../components/admin/layout/Header';
import Sidebar from '../components/admin/layout/Sidebar';
import Footer from '../components/admin/layout/Footer';
import { WebAssetsContext } from "../App";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
const Pages = (props) => {

  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const [pages, setpages] = useState([]);
  const fetchData = () => {
    fetch(api + "getpages")
      .then(res => res.json())
      .then((result) => {
        if (result.status == true) {
          setpages(result.response);
        }
      }
      )
  }
  useEffect(() => {
    fetchData();
  }, [])


  return (
    <>
       <div className="section-body">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="pt-4 pl-4 pr-4">
                        <div className="card-header pl-0 pr-0 w-50 float-left">
                          <h4 className="headercolor" >Pages List</h4>
                        </div>
                        <div className="float-right">
                          <button className="btn btn-icon icon-left btn-primary"><i className="fas fa-plus"></i> Add Page</button>
                        </div>

                      </div>
                      <div className="card-body pl-4 pr-4 pb-4 pt-0">
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>S.NO</th>
                                <th>Title</th>
                                <th width={'120px'} >Status</th>
                                <th width={'120px'} className="text-right">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {pages.length > 0 ? pages.map((page, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{page.title}</td>

                                  <td>
                                    {page.status == '1' ? <div className="badge badge-success">Complete</div> : ''}

                                    {page.status == '0' ? <div className="badge badge-danger">Pending</div> : ''}

                                  </td>

                                  <td className="text-right">

                                    <button role="button"
                                      id={'edit_' + page.id}
                                      className="btn btn-icon btn-primary mr-2" data-tooltip-content="Edit">
                                      <i className="far fa-edit"></i>
                                    </button>
                                    <Tooltip anchorId={'edit_' + page.id} />

                                    <button role="button" id={'delete_' + page.id} className="btn btn-icon btn-danger" data-tooltip-content="Delete" ><i className="far fa-trash-alt"></i></button>
                                    <Tooltip anchorId={'delete_' + page.id} />
                                  </td>

                                </tr>
                              )) :

                                <tr><td colSpan="10" className="text-center">Data not yet found. </td>
                                </tr>
                              }

                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    </>

  );
}

export default Pages;
